import z from 'zod';
export const documentIdValue = z.string().trim().min(1).brand('DocumentId');
export const createDocumentId = (value) => documentIdValue.parse(value);
export const isDocumentId = (value) => documentIdValue.safeParse(value).success;
//# sourceMappingURL=document-id.js.map